// A thin bar: honey for the level, blue for the balance.
import type { CSSProperties } from 'react';
import { cx } from './cx';

export interface MeterProps {
  /** 0 to 1. */
  value: number;
  tone?: 'honey' | 'blue';
  /** What is being measured, for the screen reader: "Progress to Duct Tape Devotee". */
  label: string;
  className?: string;
}

export function Meter({ value, tone = 'honey', label, className }: MeterProps) {
  const pct = Math.round(Math.min(1, Math.max(0, value)) * 100);
  return (
    <div className={cx('meter', tone === 'blue' && 'blue', className)} role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={pct}>
      <span className="meter-fill" style={{ '--p': pct / 100 } as CSSProperties} />
    </div>
  );
}
